<script setup>
import { useAuthStore } from '@/stores'

const props = defineProps({
  reloCompany: { 
    required: true, 
    type: [Object, null],
    default: {} 
  },
  target: {
    type: String,
    default: null,
  },
})
const { currentUser } = useAuthStore()
</script>

<template lang="pug">
template(v-if="currentUser.isManager")
  RouterLink.text-link(
    :to="{ name: 'reloCompanyShow', params: { reloCompanyId: reloCompany.id } }"
    :target="props.target"
  ) {{ reloCompany.name }}
template(v-else) {{ reloCompany.name }}  
</template>